import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/layout/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="dark grid min-h-screen place-items-center bg-[#070B14] px-5 text-white" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#0D1526] p-8">
        <Logo light testId="admin-login-logo" />
        <h1 className="mt-8 font-display text-2xl font-extrabold text-white">Admin sign in</h1>
        <p className="mt-1 text-sm text-slate-400">Manage the flight routes shown on the site.</p>
        <div className="mt-6 space-y-4">
          <div className="space-y-2"><Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" /></div>
          <div className="space-y-2"><Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" /></div>
        </div>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit"
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-amber-400 py-3 font-bold text-[#070B14] transition-opacity disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
